import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import { useIsWindowWiderThan } from '@common/hooks';
import { NameDateOption } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/Options.styles';
import { gridTheme } from '@utils/grid';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

type PerDateOption = RoomExtraOption & { name?: string; startDate?: string };

const optionsForPerDate = (options: PerDateOption[], isMobile: boolean) =>
  options.map((option, index) => ({
    label: isMobile ? (
      `${moment(option.startDate).format('MMM DD')}: ${option.name}`
    ) : (
      <NameDateOption>
        <strong>{option.name}</strong> {moment(option.startDate).format('MMM DD')}
      </NameDateOption>
    ),
    value: index,
  }));

type SelectOption = { label: string | JSX.Element; value: number };

export const PerDate = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const isMobile = !useIsWindowWiderThan(gridTheme.breakpoints.md);
  const opts = optionsForPerDate(options as PerDateOption[], isMobile);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
